import React, { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";
import MaterialSwitch from "../../styles/materialSwitch";
import DialogModal from "../../elements/dialogModal/DialogModal";
import TwoFa from "../../elements/twoFa/TwoFa";
import axios from "axios";

import { TextField } from "@material-ui/core";
import MaterialCheckbox from "../../styles/materialCheckbox";
import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";
import { StyledCheckbox, StyledFormGrid } from "../../styles/styledTabsForm";
import { StyledApplyToItem, StyledApplyToWrapper } from "../../styles/styledApplyTo";
import { parseAxiosError } from "../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { StyledSwitchWrapper } from "../../masterBalances/styledMasterBalances";
import DefaultButton from "../../styles/materialButtonStyle";

const FeeList = ({ fees, notification, setNotification, fetchBaseFee }) => {
  const { t } = useTranslation("feePage");

  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [checked, setChecked] = useState([]);
  const [massEditingData, setMassEditingData] = useState({
    min: 0,
    max: 0,
    active: true
  });
  const [singleEditId, setSingleEditId] = useState(null);

  const inputType = {
    min: "min",
    max: "max",
    active: "active"
  };

  const [currentType, setCurrentType] = useState(null);

  const onChangeApply = (event, index) => {
    setChecked((prev) => {
      const updated = [...prev];
      updated[index] = event.target.checked;
      return updated;
    });
  };

  const handleCheckAll = (event) => {
    setChecked(fees.map(() => event.target.checked));
  };

  const handleChangeActivity = (fee) => {
    setSingleEditId(fee.id);
    setMassEditingData((prev) => ({ ...prev, active: !fee.active }));
    setCurrentType(inputType.active);
    setOpen(true);
  };

  const massEditing = async (event) => {
    event.preventDefault();

    const twoFa = event.target.twofa.value;

    let data = document.getElementsByName("applyTo"), res = [];

    if (singleEditId) {
      res = [singleEditId];
    } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].checked) {
          res.push(data[i].id);
        }
      }
    }

    axios.post("/api/base-fees/mass-edit", {
      data: res,
      type: currentType,
      value: massEditingData[currentType],
      twoFa
    }, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        fetchBaseFee();
        setOpen(false);
        setSingleEditId(null);
        setNotification({ ...notification, visible: true, type: "success", message: t("edit.success") });
      }
    }).catch(error => {
      setOpen(false);
      setSingleEditId(null);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const changeInputValue = (value, type) => {
    setMassEditingData({ ...massEditingData, [type]: value });
  };

  const renderApplyButton = (action) => {
    return (
      <DefaultButton color="success" onClick={action}>
        {t("edit.applyTo")} {checked?.filter(Boolean).length}/{fees.length}
      </DefaultButton>
    );
  };

  useEffect(() => {
    setChecked(fees?.map(() => false) || []);
  }, [fees]);

  const renderMassEdit = () => {
    return (
      <StyledFormGrid className="apply-to-wrapper">
        <StyledApplyToWrapper col="3">
          <StyledApplyToItem>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("edit.min")}
              id={inputType.min}
              type="text"
              value={massEditingData.min}
              onChange={(event) => changeInputValue(event.target.value, inputType.min)}
            />
            {renderApplyButton(() => {
              setCurrentType(inputType.min);
              setOpen(true);
            })}
          </StyledApplyToItem>
          <StyledApplyToItem>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("edit.max")}
              id={inputType.max}
              type="text"
              value={massEditingData.max}
              onChange={(event) => changeInputValue(event.target.value, inputType.max)}
            />
            {renderApplyButton(() => {
              setCurrentType(inputType.max);
              setOpen(true);
            })}
          </StyledApplyToItem>
          <StyledApplyToItem>
            <StyledSwitchWrapper>
              <div>
                {t("details.changeForm.active")}
              </div>
              <MaterialSwitch
                id="baseFeeActivity"
                name="Base fee activity"
                checked={massEditingData.active}
                onChange={(event) => changeInputValue(event.target.checked, inputType.active)}
                label={t("details.changeForm.active")}
              />
            </StyledSwitchWrapper>
            {renderApplyButton(() => {
              setCurrentType(inputType.active);
              setOpen(true);
            })}
          </StyledApplyToItem>
        </StyledApplyToWrapper>
      </StyledFormGrid>
    );
  };

  if (!fees) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (fees.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("table.twoFa")}
        content={<TwoFa
          handleSubmit={massEditing}
          error={error}
        />}
      />
      {renderMassEdit()}
      <StyledScrollTable>
        <StyledTable
          width="1800"
          size="14"
        >
          <StyledTableHead
            scroll="auto"
            col="12"
          >
            <div>
              <StyledCheckbox position="center">
                <MaterialCheckbox
                  type="checkbox"
                  name="checkAll"
                  id="checkAll"
                  checked={checked?.length > 0 ? checked.every(Boolean) : false}
                  indeterminate={checked?.length > 0 && checked.some(Boolean) && !checked.every(Boolean)}
                  onChange={handleCheckAll}
                />
              </StyledCheckbox>
            </div>
            <div>
              {t("table.active")}
            </div>
            <div>
              {t("table.service")}
            </div>
            <div>
              {t("table.paymentSystem")}
            </div>
            <div>
              {t("table.currency")}
            </div>
            <div>
              {t("table.type")}
            </div>
            <div>
              {t("table.percent")}
            </div>
            <div>
              {t("table.constant")}
            </div>
            <div>
              {t("table.constantInUSDT")}
            </div>
            <div>
              {t("table.min")}
            </div>
            <div>
              {t("table.max")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {fees && fees.map((value, index) => (
              <StyledTableRow
                key={index}
                scroll="auto"
                col="12"
              >
                <StyledCol>
                  <StyledCheckbox position="center">
                    <MaterialCheckbox
                      type="checkbox"
                      name="applyTo"
                      id={value.id}
                      checked={checked?.[index] || false}
                      onChange={(event) => onChangeApply(event, index)}
                    />
                  </StyledCheckbox>
                </StyledCol>
                <StyledCol>
                  <MaterialSwitch
                    checked={value.active}
                    onChange={() => handleChangeActivity(value)}
                    label={t("details.changeForm.active")}
                  />
                </StyledCol>
                <StyledCol>
                  {getServiceNameWithNickname(value.service.name, value.service.nickname)}
                </StyledCol>
                <StyledCol>
                  {value.paymentSystem.name}
                </StyledCol>
                <StyledCol>
                  {value.currency.asset}
                </StyledCol>
                <StyledCol>
                  {value.type}
                </StyledCol>
                <StyledCol>
                  {Math.round((value.percent * 100) * 1000) / 1000} %
                </StyledCol>
                <StyledCol>
                  {value.constant}
                </StyledCol>
                <StyledCol>
                  {value.constantInUSDT}
                </StyledCol>
                <StyledCol>
                  {value.min}
                </StyledCol>
                <StyledCol>
                  {value.max}
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};

export default FeeList;
